import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { isTouchDevice } from '../../../utils/detect'

// styles
import './stickycontainer.scss'

class StickyContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.getDistanceFromTop = this.getDistanceFromTop.bind(this)
  }

  componentDidMount () {
    const el = Array.from(document.querySelectorAll('.sticky'))[this.props.order]
    const shortcuts = document.querySelector('.layout__shortcuts.horizontal')
    this.setState({
      top: el.getBoundingClientRect().top,
      height: el.offsetHeight,
      width: el.offsetWidth,
      posRight: el.getBoundingClientRect().right,
      offset: shortcuts.offsetHeight
    })
    window.addEventListener('scroll', this.handleScroll, true)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll, true)
  }

  handleScroll () {
    const appDiv = document.getElementById('app')
      // appDiv.scrollTop > this.state.top - pos ? el.style.paddingTop = `${this.state.height + pos}px` : el.style.paddingTop = 0
    this.setState({
      scroll: appDiv.scrollTop
    })
  }

  getDistanceFromTop () {
    // if not first sticky div, account for the others before it, when setting top position
    let fixedStickies = Array.from(document.querySelectorAll('.sticky')).slice(0, this.props.order)
    const dist = fixedStickies.reduce((distanceTop, el) => {
      distanceTop += el.offsetHeight
      return distanceTop
    }, 0)

    return this.state.offset + dist
  }

  render () {
    let stickyClass = 'sticky'
    let dist = this.getDistanceFromTop()
    let style

    if (this.state.scroll >= this.state.top - dist) {
      stickyClass += ' fixed_sticky'
      const el = Array.from(document.querySelectorAll('.sticky'))[this.props.order]
      el.style.top = `${this.props.order > 0 ? dist : this.state.offset}px`
    }

    // to fix multiple sticky components used, where some could conflict like a dropdown
    if (this.props.specificIndex && Number.isInteger(this.props.specificIndex)) style = { zIndex: this.props.specificIndex }
    return (
      <div ref='sticky' className={stickyClass} style={style} >
        {this.props.renderContent()}
      </div>
    )
  }
}

StickyContainer.PropTypes = {
  renderContent: PropTypes.func,
  order: PropTypes.required
}

export default StickyContainer



// WEBPACK FOOTER //
// ./src/app/shared/components/StickyContainer/index.js